import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import ProjectPage from "./pages/ProjectPage";
import BlogPage from "./pages/BlogPage";
import BlogArticle from "./pages/BlogArticle";
import RahataniGuidePage from "./pages/RahataniGuidePage";
import DMartFlatsPage from "./pages/DMartFlatsPage";
import ThreeBhkCollectionPage from "./pages/ThreeBhkCollectionPage";
import SilverWoodsLandingPage from "./pages/SilverWoodsLandingPage";
import NotFoundPage from "./pages/NotFoundPage";
import WhatsAppButton from "./components/WhatsAppButton";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/project/:slug" element={<ProjectPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/rahatani-guide-2026" element={<RahataniGuidePage />} />
          <Route path="/flats-near-dmart-thergaon" element={<DMartFlatsPage />} />
          <Route path="/3-bhk-collection-rahatani" element={<ThreeBhkCollectionPage />} />
          <Route path="/2-bhk-flats-rahatani-pune" element={<SilverWoodsLandingPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <WhatsAppButton />
        <Toaster 
          position="top-center" 
          toastOptions={{
            style: {
              background: '#111111',
              color: '#FFFFFF',
              border: '1px solid rgba(255,255,255,0.06)'
            }
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
